<template>
  <div class="container-fluid">
    <el-container>
      <el-header height="15%">
        <el-alert v-if="status===200"
                  title="Товар успешно удален."
                  type="success"
                  effect="dark">
        </el-alert>
        <el-alert v-if="message==='articles'"
                  title="Ошибка, о данном товаре рассказывается в статье"
                  type="error"
                  effect="dark">
        </el-alert>
        <el-alert v-if="message==='promoActions'"
                  title="Ошибка, данный товар участвует в акции"
                  type="error"
                  effect="dark">
        </el-alert>
        <el-alert v-if="message==='orders'"
                  title="Ошибка, данный товар существует в сделанном заказе"
                  type="error"
                  effect="dark">
        </el-alert>
        <div class="row m-4">
          <div class="col-md-1">
            <h4>Товары</h4>
          </div>
        </div>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск" label-width="140px" label-position="left">
          <el-row>
            <el-col :lg="12" :xl="8">
              <el-form-item label="Поиск">
                <el-col :span="14">
                  <el-input v-model="query.q" @change="setQueryReset"></el-input>
                </el-col>

              </el-form-item>
            </el-col>
            <el-col :lg="12" :xl="8">
              <el-form-item label="Поиск по категории">
                <el-button size="small" type="primary" @click="toggleDialog()">Выбрать</el-button>
                  <el-tag v-if="selectedSections.length" closable @close="handleDeleteCat">
                    Выбрано: {{ selectedSections.length }}
                  </el-tag>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :xl="8">
              <el-form-item label="Сортировка">
                <el-select
                v-model="query.sort"
                :width="300"
                placeholder="Сортировка"
                no-data-text="Нет данных"
                @change="setQuery"
                >
                  <el-option
                  v-for="item in sortConfig"
                  :key="item.field"
                  :value="item.field"
                  :label="item.title"
                  />
                </el-select>
              </el-form-item>              
            </el-col>
            <!-- <el-col :span="6">
              <el-button @click="deleteProductsWithoutGroups">Удалить товары без группы</el-button>
            </el-col> -->
          </el-row>
        </el-form>
        <el-table
            :data="products"
            style="width: 100%"
            v-loading="loading"
            empty-text="Не продуктов"
        >
          <el-table-column
              prop="id"
              label="Id"
              width="80">
          </el-table-column>
          <!-- <el-table-column
              prop="slug"
              label="Slug"
              width="150">
          </el-table-column> -->
          <el-table-column
              prop="title"
              label="Название"
              >
          </el-table-column>

          <el-table-column
              prop="article"
              label="Артикул"
              width="100">
          </el-table-column>
          <el-table-column
              label="Разделы каталога"
              >
            <template slot-scope="scope">
              <template  v-if="products[scope.$index].section">
                {{products[scope.$index].section.path}}                
              </template>
            </template>
          </el-table-column>
            <el-table-column
              prop="sort"
              label="Сортировка"
            >
            </el-table-column>

            <el-table-column
                    label="Активность"
            >
                <template slot-scope="scope">
                    <p v-if="!products[scope.$index].activity">Нет</p>
                    <p v-if="products[scope.$index].activity">Да</p>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="Действия"
                    width="400">
                <template slot-scope="scope">
                    <el-button v-if="products[scope.$index].activity"
                      size="mini"
                      type="primary"
                      plain
                      @click="hideRow(scope.$index)">Скрыть</el-button>
                    <el-button v-if="!products[scope.$index].activity"
                      size="mini"
                      type="primary"
                      plain
                      @click="restoreRow(scope.$index)">Восстановить</el-button>
                    <el-button
                      size="mini"
                      @click="updateRow(scope.$index)">Изменить</el-button>
                </template>
            </el-table-column>

        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
            background
            layout="prev, pager, next"
            :total="paginator.total"
            :current-page.sync="paginator.current_page"
            @current-change="getPage(paginator.current_page)"
            :hide-on-single-page="true"
            :page-size="paginator.per_page"
            :page-count="paginator.last_page"
        >
        </el-pagination>
      </el-footer>
    </el-container>
      <CatalogSectionDialog
        v-if="$store.getters.showCatalogSectionDialog"
        :items-payload="selectedSections"
        :returns-ids="true"
        @saveItems="onSaveItems"
      />
  </div>
</template>

<script>
import axios from "axios";
import sortConfig from '../../composable/config/products-sort.config'
import { SETPRELOADER_STATE } from '@/store/mutation-types'
import CatalogSectionDialog from '../CatalogSectionDialog'

export default {
  components: {CatalogSectionDialog},
  name: "Products",
  data: function (){
    return{
      sortConfig,
      products:[],
      paginator:[],
      status:0,
      message:'',
      current:0,      
      query:{
        section:[],
        q:'',
        sort: '',
        page: 1,
      },
      selectedSections:[],
      loading: false

    }
  },
  computed: {
    activeSort() {
        const result = this.sortConfig.find((e) => e.field === this.query.sort)
        return result ? result.options  : undefined
    },
  },
  mounted() {
    this.initParams(this.$route.query);
    this.getProducts(this.getQuery(this.$route.query));
  },
  watch:{
    '$route.query'(v){   
      const query = this.getQuery(v)   
            if (query){              
                this.getProducts(query)
            }
        }
    },
  methods: {
    getProducts: function (query){      
      this.$store.commit(SETPRELOADER_STATE, true)
      axios.get('product'  + query).then((response)=>
          {
            this.products = response.data.data;
            this.paginator = response.data.meta;
          }
      ).catch((errors)=>{
        if(errors.response.status === 401){
          this.$router.push('/login');
        }
      })
      .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
    },
    goToPage: function (path){
      this.$router.push(path);
    },
    hideRow: function (index) {
        let id = this.products[index].id;

        axios.post('/product/'+id+'/hide').then(()=>{
            this.$notify.success('Товар скрыт')  
            this.updatePage()          
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
        });

    },
    restoreRow: function (index) {
        let id = this.products[index].id;

        axios.post('product/'+id+'/restore').then(()=>{
            this.$notify.success('Товар восстановлен')            
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
        });

    },
    updateRow: function (index) {
      let id = this.products[index].id;
      this.$store.commit('productId',id);
      this.$router.push('/product/'+id+'/update');

    },
    getPage: function(pageNum){
      if (pageNum){
        this.query.page = pageNum
        this.setQuery();  
      }

    },

    updatePage(){
      this.getProducts(this.getQuery(this.$route.query));
    },

    setQueryReset(){
        this.query.page = 1
        this.setQuery()
    },

    setQuery(){
        const result = {}
        let isChange = false;
        if (this.activeSort) {
            isChange = true
            result['sort']= {
              by: this.activeSort.by,
              order: this.activeSort.order
            }
        }
        if(this.query.q){
          isChange = true
          result['q']=this.query.q
        }

        if (this.query.section) {
            isChange = true
            result['section_id']=this.query.section
        }
        if(this.query.page){
            isChange = true
            result['page']=this.query.page
        }

        if (isChange) {
            const q = this.getQuery(result)
            this.$router.push({
              path: 'products' + q,
            })
        }
    }, 
    getQuery(query) {
        if (Object.keys(query).length > 0){        
            const qs = require('qs');
            return `?${qs.stringify(query)}`
        }
        return ''
    },
    initParams(query){
        if (!query){
            return
        }
        const qs = require('qs');
        const parseQuery= qs.parse(query);

        if (parseQuery.sort?.by && parseQuery.sort?.order) {
          this.query.sort = `${parseQuery.sort.by}.${parseQuery.sort.order}`
        }
        if (parseQuery.q){
            this.query.q = query.q
        }

        if (parseQuery.section_id){
            this.query.section = Number.parseInt(parseQuery.section_id)
            this.selectedSections = [this.query.section]
        }
        if (parseQuery.page){
            this.query.page = parseQuery.page
        }
    },
    toggleDialog() {
      this.$store.commit('showCatalogSectionDialog', !this.$store.getters.showCatalogSectionDialog);
    },
    setFormSection(){
      this.query.section = this.selectedSections[0] ?? '';
      
    },
    handleDeleteCat(){
      this.selectedSections = []
      this.setFormSection()
      this.setQuery()
    },
    onSaveItems(items) {
      this.selectedSections = items
      this.setFormSection()
      this.setQuery()
    }

  },
}
</script>

<style scoped>

</style>